import { c as _c } from "react/compiler-runtime";
import type { Entity, WorkflowSource } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
export type AbandonedEventHeaderProps = {
  entity: Entity;
  workflowSource: WorkflowSource;
};
const AbandonedEventHeader = t0 => {
  const $ = _c(7);
  const {
    entity,
    workflowSource
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.abandonedEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== entity.kind || $[2] !== t || $[3] !== workflowSource) {
    t2 = entity.kind === "person" && workflowSource !== "hosted" ? t(_temp) : t($_0 => $_0.title[entity.kind]);
    $[1] = entity.kind;
    $[2] = t;
    $[3] = workflowSource;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const title = t2;
  let t3;
  if ($[5] !== title) {
    t3 = <p className="text-label-2 text-warning">{title}</p>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default AbandonedEventHeader;
function _temp($) {
  return $.title.incomplete;
}